import React, { useEffect } from 'react'

// components
import FilterDropdown from './FilterDropdown'
import { Dropdown } from 'rsuite'

// redux
import { useSelector, useDispatch } from 'react-redux'
import { getOptions, getContextOptions, getYou } from '../redux/options/selectors' 
import { setOption } from '../redux/options/actions' 
import { getGroupList, getIsOfficialRace, getData } from '../redux/data/selectors'
import { FAVOURITES, FAVOURITES_LABEL } from '../tools/Favourites'
import { getGroupName, ALL_CARS_LABEL } from '../tools/Groups'
import Icon from './Icon'

const GroupDropdown = ( { showAll = true, context = 'filters', onChange = null } ) =>
{
  // get all options
  const options = useSelector( getOptions )     
  // try to get filters from context
  const { group = '' } = getContextOptions( options, context )
  // other selectors
  const groups = useSelector( getGroupList )
  const official = useSelector( getIsOfficialRace )
  const you = useSelector( getYou )
  const loaded = useSelector( getData ).length > 0

  // dispatchers  
  const dispatch = useDispatch()
  const onSelect = g =>
  {
    dispatch( setOption( 'group', g, context ) )
    if ( onChange ) onChange( g )
  }

  // a stored group without laps in the shown race, such as favourites that did not race or any group in a
  // race without groups, means all groups; only once laps are loaded, and where all groups can be chosen;
  // the group page picks its own fallback
  useEffect( () =>
  {
    if ( !showAll || !group || !loaded ) return
    if ( !groups.some( g => String( g ) === String( group ) ) )
    {
      dispatch( setOption( 'group', '', context ) )
    }
  }, [ group, groups, loaded ] )

  /**
   * Get the group name as the list shows it, the favourites group with its star
   * @param {number|string} group group key
   * @returns {string|JSX.Element} group name
   */
  const getListName = ( group = '' ) =>
  {
    if ( group === FAVOURITES )
    {
      return <React.Fragment>{ FAVOURITES_LABEL } <Icon icon="star" className="favourite"/></React.Fragment>
    }
    return getGroupName( group )
  }

  // nothing to choose in a race without groups or favourites
  if ( !groups.length ) return null

  // render the dropdown
  return (
    <FilterDropdown
      className="filter-group"
      title={ group ? getGroupName( group ) : 'Group' }
      icon="hashtag"
      selectAll={ official ? 'All groups' : ALL_CARS_LABEL }
      onSelect={ onSelect }
      selected={ group }
      showAll={ showAll }
    >
      { groups.map( i => (
          <Dropdown.Item key={ `key-${i}` } eventKey={ i } className={ you && String( you ).indexOf( i ) === 0 ? 'you' : '' }>
          { getListName( i ) }
          { you && String( you ).indexOf( i ) === 0 && <Icon icon="avatar" key="avatar" /> }
          </Dropdown.Item> 
        ) ) }
    </FilterDropdown>
  )
}

export default GroupDropdown